var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMtfalart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFE8E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_16841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_16841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 17.0999V11.9999H15.3333V17.0999L14.3333 16.1666L13.3333 17.0999ZM16.6667 18.0999V9.33325H18.6667V16.0999L16.6667 18.0999ZM10 20.3999V14.6666H12V18.3999L10 20.3999ZM10 22.0333L14.3 17.7333L16.6667 19.7666L20.4 16.0333H19.3333V14.6999H22.6667V18.0333H21.3333V16.9666L16.7333 21.5666L14.3667 19.5333L11.8667 22.0333H10Z",
    fill: "#F60000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtfalart);
export default __webpack_public_path__ + "static/media/mtfalart.6641932a231fed8f66f30412778bd468.svg";
export { ForwardRef as ReactComponent };